export default __webpack_public_path__ + "static/media/drew_profile_pic.46f36b66.png";